import { Entity } from "./Entity";

export class EntitySet extends Set<Entity> {
  groups = <Record<string, Set<Entity>>>{};

  add(entity: Entity): this {
    super.add(entity);
    const { group } = entity;
    if (!group) return this;
    if (!this.groups[group]) this.groups[group] = new Set<Entity>();
    this.groups[group].add(entity);
    return this;
  }

  delete(entity: Entity): boolean {
    const did_exist = super.delete(entity);
    const { group } = entity;
    if (group) this.groups[group]?.delete(entity);
    return did_exist;
  }
}
